import validateTemplateBase64Data from "./validateTemplateBase64Data";
const validateUserCreationForm = (data) => {
  let errors = {};

  if (!data.email || !/\S+@\S+\.\S+/.test(data.email)) {
    errors.email = "Invalid email address";
  }

  if (!data.mobileNumber || !/^\d{10}$/.test(data.mobileNumber)) {
    errors.mobileNumber = "Invalid mobile number";
  }

  if (!data.userName || data.userName.trim() === "") {
    errors.userName = "Name is required";
  }

  if (!data.role || data.role.trim() === "") {
    errors.role = "User Role is required";
  }

  const base64FingerprintData =
    "Rk1SACAyMAAAAACWAAABLAGQAMUAxQEAAABPFIC+" +
    "AG9uAICIAHN4AEDmAIZpAICLAMR/AEAyAMURAEDHANTjAEDBAN7bAECKAOF7AEA3AO+" +
    "iAIBtAPYJAECvAPnWAEB3ARG1AECPARnDAIBIAR68AEBvAR67AEBqASEzAEB4ASK4AEBzASU6AIDVAS2/" +
    "AIBzAUUwAAAA";

  if (!validateTemplateBase64Data(base64FingerprintData)) {
    errors.role = "Please scan your fingerprint again";
  }

  if (!data.profileImage || data.profileImage.trim() === "") {
    errors.profileImage = "Profile Image is required";
  }

  // if (!data.userId || data.userId.trim() === '') {
  //     errors.userId = 'User Id is Invalid';
  // }
  return errors;
};

export default validateUserCreationForm;
